<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <v-container>
      <ik-data-table
        ref="table"
        :model="model"
        :use-delete-action="false"
        entity-name="vipManage"
        icon="mdi-cash-usd"
      >
        <template
          #item.checkDetail="{item}"
        >
          <v-btn
            :height="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
            :icon="!$vuetify.breakpoint.lgAndUp"
            :style="!$vuetify.breakpoint.lgAndUp ? 'border-radius: 12px; background: #f57c00;' : ''"
            :width="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
            color="amber lighten-4 black--text"
            elevation="0"
            small
            @click.stop="goto(item)"
          >
            <template v-if="!$vuetify.breakpoint.lgAndUp">
              <v-icon color="white">
                mdi-cog
              </v-icon>
            </template>
            <template v-if="$vuetify.breakpoint.lgAndUp">
              <div
                :class="!$vuetify.breakpoint.lgAndUp ? 'text-truncate' : ''"
                :style="!$vuetify.breakpoint.lgAndUp ? 'max-width: 100px;' : ''"
              >
                {{ $t('Details') }}
              </div>
            </template>
          </v-btn>
        </template>
        <template
          #item.recharge="{item}"
        >
          <v-btn
            :height="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
            :icon="!$vuetify.breakpoint.lgAndUp"
            :style="!$vuetify.breakpoint.lgAndUp ? 'border-radius: 12px; background: #f57c00;' : ''"
            :width="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
            color="amber lighten-4 black--text"
            elevation="0"
            small
            @click.stop="memberRecharge(item)"
          >
            <template v-if="!$vuetify.breakpoint.lgAndUp">
              <v-icon color="white">
                mdi-cog
              </v-icon>
            </template>
            <template v-if="$vuetify.breakpoint.lgAndUp">
              <div
                :class="!$vuetify.breakpoint.lgAndUp ? 'text-truncate' : ''"
                :style="!$vuetify.breakpoint.lgAndUp ? 'max-width: 100px;' : ''"
              >
                {{ $t('recharge') }}
              </div>
            </template>
          </v-btn>
        </template>
      </ik-data-table>
    </v-container>
    <v-dialog
      v-model="showDetailInfoDialog"
      :fullscreen="$vuetify.breakpoint.mobile"
      max-width="1000px"
    >
      <v-card
        v-if="showDetailInfoDialog"
        color="#f6f6f6"
        tile
      >
        <vip-member-detail
          :member-identity="memberIdentity"
          @close-dialog="showDetailInfoDialog=false"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="rechargeDialog"
      max-width="500px"
      persistent
    >
      <base-form
        :schema="schemas"
        @close="rechargeDialog=false"
        @submit="saveRecharge"
      >
        <div>{{ $t('PlannedSettings') }}</div>
        <template #subtitle>
          {{ $t('PlannedSettingsHint') }}
        </template>
      </base-form>
    </v-dialog>
  </div>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import VipApi from '@/model/dataLayer/api/Vip/VipApi'
import VipMemberDetail from '@/views/AadenPages/VipPage/VipMemberDetail'
import BaseForm from '@/views/widget/INK/BaseForm/BaseForm'
import { VSelect } from 'vuetify/lib/components'
import CashBox from '@/model/dataLayer/api/CashBox/CashBox'
import Servant from '@/model/dataLayer/api/tableAndPerson/Servant'
import VipPay, { memberRechargeFunc } from '@/model/dataLayer/api/Vip/VipPay'
import payment from '@/model/dataLayer/api/common/Payment'

export default {
  components: {
    BaseForm,
    VipMemberDetail,
    IkDataTable
  },
  data: function () {
    return ({
      paymentList: [],
      currentMemberId: '',
      nfcMenuList: [],
      servantList: [],
      cashBoxList: [],
      rechargeDialog: false,
      showDetailInfoDialog: false,
      model: VipApi,
      memberIdentity: ''
    })
  },
  computed: {
    schemas () {
      return [
        {
          key: 'nfcMenuId',
          name: 'RechargeType',
          component: VSelect,
          componentProps: {
            items: this.nfcMenuList.map(it => {
              it.text = it.name
              it.value = it.id
              return it
            })
          }
        },
        {
          key: 'payment',
          name: 'PaymentMethod',
          component: VSelect,
          componentProps: {
            items: this.paymentList.map(it => {
              it.text = it.name
              it.value = it.id
              return it
            })
          }
        },
        {
          key: 'pw',
          name: 'staff',
          component: VSelect,
          componentProps: {
            items: this.servantList.map(it => {
              it.text = it.name
              it.value = it.password
              return it
            })
          }
        },
        {
          key: 'cashBoxId',
          name: 'PosId',
          component: VSelect,
          componentProps: {
            items: this.cashBoxList.map(it => {
              it.text = it.name
              it.value = it.id
              return it
            })
          }
        }
      ]
    }
  },
  async mounted () {
    this.paymentList = await payment.getList(true)
    this.nfcMenuList = await VipPay.getList(true)
    this.servantList = await Servant.getList(true)
    this.cashBoxList = await CashBox.getList(true)
  },
  methods: {
    async saveRecharge (info) {
      const price = this.nfcMenuList.find(it => it.id === info.nfcMenuId).amountToPay
      info.uid = this.currentMemberId
      info.paymentLog = JSON.stringify([{ id: info.payment, price }])
      console.log(info, 'info')
      await memberRechargeFunc(info)
      this.rechargeDialog = false
      await this.$refs.table.reload()
    },
    async goto (item) {
      this.memberIdentity = item.memberIdentity
      this.showDetailInfoDialog = true
    },
    memberRecharge (item) {
      this.rechargeDialog = true
      this.currentMemberId = item.simpleMemberUuid
    }
  }
}
</script>
